exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Table2.m.scss","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/Table2/Table2.m.scss
// module id = 1179
// module chunks = 74